import React from 'react';

export default () => (
  <div className="page-not-found">
    404
  </div>
);
